import { FormControl, FormGroup, Validators } from '@angular/forms';
import {
  FRACTIONAL_NUMBER_PATTERN,
  NATURAL_NUMBER_PATTERN,
  NUMBER_PATTERN,
  UliActivityType,
  UliOrigin,
  VALIDATION_RULES,
} from '../../../../../../common';
import { LocalDate, LocalDateFormGroup, LocalDateModel } from '../../../../../models';

export class AllocationUliDetails {
  compartmentId: number;
  compartmentName: string;
  allocatedCompartmentId: number;
  allocatedCompartmentName: string;
  customsGoods = false;
  dangerousGoods = false;
  complete: boolean;
  numberOfHu: number;
  scheduledArrivalTime: LocalDate;
  scheduledDepartureTime: LocalDate;
  slotStartTime: LocalDate;
  type: UliActivityType;
  uli: string;
  origin: UliOrigin;
  consignmentItems: number;
  loadNumber: string;
  loadingMeters: number;
  weightGross: number;
  selected: boolean;

  constructor(params?: AllocationUliDetails) {
    if (params) {
      Object.assign(this, params);

      const { scheduledArrivalTime, scheduledDepartureTime } = params;

      if (scheduledArrivalTime) {
        this.scheduledArrivalTime = new LocalDateModel({
          ...scheduledArrivalTime,
          timestamp: +LocalDateModel.getLocalDateByOffset(scheduledArrivalTime),
        });
      }

      if (scheduledDepartureTime) {
        this.scheduledDepartureTime = new LocalDateModel({
          ...scheduledDepartureTime,
          timestamp: +LocalDateModel.getLocalDateByOffset(scheduledDepartureTime),
        });
      }
    }
  }
}

export class AllocationUliDetailsForm {
  constructor(
    model: AllocationUliDetails,
    public compartmentId: FormControl<number> = new FormControl(model ? model.compartmentId : null),
    public allocatedCompartmentId: FormControl<number> = new FormControl(model ? model.allocatedCompartmentId : null),
    public compartmentName: FormControl<string> = new FormControl(model ? model.compartmentName : null),
    public allocatedCompartmentName: FormControl<string> = new FormControl(
      model ? model.allocatedCompartmentName : null,
    ),
    public selected: FormControl<boolean> = new FormControl(model ? model.selected : false),
    public complete: FormControl<boolean> = new FormControl(model ? model.complete : true),
    public uli: FormControl<string> = new FormControl(model ? model.uli : null),
    public origin: FormControl<string> = new FormControl(model ? model.origin : null),
    public loadNumber: FormControl<string> = new FormControl(model ? model.loadNumber : null),
    public scheduledArrivalTime: FormGroup<LocalDateFormGroup> = new FormGroup(
      new LocalDateFormGroup(model.scheduledArrivalTime),
      {
        validators: [Validators.required],
      },
    ),
    public scheduledDepartureTime: FormGroup<LocalDateFormGroup> = new FormGroup(
      new LocalDateFormGroup(model.scheduledDepartureTime),
      {
        validators: [Validators.required],
      },
    ),
    public slotStartTime: FormControl<LocalDate> = new FormControl(model ? model.slotStartTime : null),
    public numberOfHu: FormControl<number> = new FormControl(model ? model.numberOfHu : null, [
      Validators.required,
      Validators.pattern(NATURAL_NUMBER_PATTERN),
      Validators.maxLength(VALIDATION_RULES.weight.maxLength),
    ]),
    public consignmentItems: FormControl<number> = new FormControl(model ? model.consignmentItems : null, [
      Validators.required,
      Validators.pattern(NUMBER_PATTERN),
    ]),
    public weightGross: FormControl<number> = new FormControl(model ? model.weightGross : null, [
      Validators.required,
      Validators.pattern(FRACTIONAL_NUMBER_PATTERN),
      Validators.maxLength(VALIDATION_RULES.weight.maxLength),
    ]),
    public type: FormControl<UliActivityType> = new FormControl(model ? model.type : null),
    public loadingMeters: FormControl<number> = new FormControl(model ? model.loadingMeters : null, [
      Validators.pattern(FRACTIONAL_NUMBER_PATTERN),
    ]),
    public customsGoods: FormControl<boolean> = new FormControl(model ? model.customsGoods : null),
    public dangerousGoods: FormControl<boolean> = new FormControl(model ? model.dangerousGoods : null),
  ) {}
}
